import { onMount } from "@/modules/_";
import { Scroll } from "@lib/scroll";

export default function (element: HTMLElement, dataset: any) {
  const homeNavContent = element.querySelector("[data-home-nav-content]");

  onMount(() => {
    Scroll.on("scroll", () => {
      if (Scroll.actualScroll > 20) {
        homeNavContent?.classList.add("hide");
      } else {
        homeNavContent?.classList.remove("hide");
      }
    });
  });
}
